<template>
  <div class="">
    <iframe
      v-if="url"
      :src="url"
      sandbox="allow-forms allow-scripts allow-pointer-lock allow-same-origin allow-top-navigation allow-presentation"
      style="width: 100%; max-width: 100%; height: 100vh"
      allow="fullscreen"
      title="IELTS"
    ></iframe>
  </div>
</template>

<script>
import homeServices from "@/apiServices/homeServices";

export default {
  name: "IeltsDoc",
  data() {
    return {
      url: "",
    };
  },

  components: {},

  methods: {
    async getPresentation(ftp_id) {
      try {
        const res = await homeServices.getPresentationById(ftp_id);
        console.log(res);
        if (res.data.status) {
          this.url = res.data.data.ftp_url;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  beforeMount() {
    const { ftp_id } = this.$route.params;
    if (!isNaN(ftp_id) && ftp_id) {
      this.getPresentation(ftp_id);
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/partials/IeltsDoc.vue